module.exports = __webpack_public_path__ + "static/media/a1.281109e2.png";